<div *ngIf="products | async as productList " class="similar-products ">
  <!-- Bouton précédent -->
  <button
    mat-button
    class="prev-button"
    (click)="prev()"
    fxHide.lt-md="true"
    *ngIf="showArrowLeft && productList.length >= 4"
  >
    <img src="assets/icons/chevron_left.svg" alt="previous" />
  </button>

  <!-- Shimmer loader -->
   <!-- Useless and is generating an issue -->
  <!-- <owl-carousel-o [options]="customOptions" *ngIf="(similarProducts && productList.length === 1) || (!similarProducts && productList.length === 0)">
    <ng-template carouselSlide *ngFor="let i of [1,2,3,4]">
      <app-product-card-shimmer></app-product-card-shimmer>
    </ng-template>
  </owl-carousel-o> -->

  <!-- Carrousel avec produits -->
   <div [ngClass]="{'small-quantity': productList.length < 4}">
     <owl-carousel-o 
       [options]="customOptions" 
       #owlCar 
       *ngIf="productList.length > 0"  >
       <ng-template carouselSlide *ngFor="let product of productList">
         <app-product-card [product]="product"></app-product-card>
       </ng-template>
     </owl-carousel-o>
   </div>


  <!-- Bouton suivant -->
  <button
    mat-button
    class="next-button"
    (click)="next()"
    fxHide.lt-md="true"
    *ngIf="showArrowRight && productList.length >= 4"
  >
    <img src="assets/icons/chevron_right.svg" alt="next" />
  </button>
</div>
